import api from "@/api.js";

export default {
  namespaced: true,
  modules: {},
  state: {
    list: [],
    listLoading: false,
  },
  mutations: {
    setList(state, payload) {
      state.list = payload;
    },
    setListLoading(state, payload) {
      state.listLoading = payload;
    },
  },
  actions: {
    async loadAll({ commit }) {
      commit("setListLoading", false);
      let list = await api.get("/outcomes/categories");
      commit("setList", list.data);
      commit("setListLoading", false);
    },
    async loadAllByOutcomesID({ commit }, id) {
      commit("setListLoading", false);
      let list = await api.get("/outcomes/categories/byOutcomesID", {
        params: { id: id },
      });
      commit("setList", list.data);
      commit("setListLoading", false);
    },

    async save({ dispatch }, payload) {
      let returnData = {};
      await api
        .put(`/outcomes/categories`, payload)
        .then((response) => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data,
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data,
            };
          }
        })
        .catch((err) => {
          returnData = {
            Result: "Error",
            Response: {
              Message: "There was an Error, Please try again later",
            },
          };
        });
      dispatch("loadAll");
      return returnData;
    },
  },
  getters: {
    list(state) {
      return state.list;
    },
    listLoading(state) {
      return state.listLoading;
    },
    listForData(state) {
      return state.list.filter((s) => s.dataCount > 0);
    },
  },
};
